import type { ThemeConfig } from 'antd';

/**
 * "Ledger & ink" — the app's own identity on top of standard AntD v5 UX:
 * forest green primary instead of AntD's default blue, a warm paper page
 * background, and Roboto as the UI typeface (self-hosted via @fontsource —
 * the app must work on a LAN without internet). The "Financiar" wordmark
 * uses the same family at weight 700 (`.brand` in global.css).
 */
export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#0F6E4F',
    colorInfo: '#0F6E4F',
    borderRadius: 6,
    fontFamily: "'Roboto', system-ui, sans-serif",
    colorBgLayout: '#f6f5f1',
    fontSize: 14,
  },
  components: {
    Table: {
      headerBg: '#eeede7',
    },
  },
};
